module.exports = __webpack_public_path__ + "img/erweima24.43dd379e.jpeg";